import { gql } from "@apollo/client";

export const MUTATION_CREATE_CARRIER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateCarrierFundingRequest(
    $amount: Int
    $debtor: String
    $billToCompanyPhone: String
    $billToCompanyEmail: String
    $streetOne: String
    $city: String
    $state: String
    $zip: String
    $country: String
    $userLoadNumber: String
    $fuelAdvanceAmount: Int
    $nonFactored: Boolean
    $markedAsCompleted: Boolean
    $autoInvoice: Boolean
    $userReferenceNumber: String
    $userNotes: String
  ) {
    createOrUpdateCarrierFundingRequest(
      input: {
        amount: $amount
        debtor: $debtor
        billToCompanyPhone: $billToCompanyPhone
        billToCompanyEmail: $billToCompanyEmail
        billToAddress: {
          streetOne: $streetOne
          city: $city
          state: $state
          zip: $zip
          country: $country
        }
        userLoadNumber: $userLoadNumber
        paymentMethod: "ach"
        fuelAdvanceAmount: $fuelAdvanceAmount
        nonFactored: $nonFactored
        contractType: "STD_CARRIER"
        markedAsCompleted: $markedAsCompleted
        autoInvoice: $autoInvoice
        userReferenceNumber: $userReferenceNumber
        userNotes: $userNotes
      }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_CARRIER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateCarrierFundingRequest(
    $id: ID
    $amount: Int
    $debtorAdvanceAmount: Int
    $debtor: String
    $contractType: String
    $userLoadNumber: String
    $billToCompanyPhone: String
    $billToCompanyEmail: String
    $streetOne: String
    $city: String
    $state: String
    $zip: String
    $country: String
    $fuelAdvanceAmount: Int
    $nonFactored: Boolean
    $originLocations: LoadLocationInputType
    $destinationLocations: LoadLocationInputType
    $autoInvoice: Boolean
    $markedAsCompleted: Boolean
    $status: String
    $statusNote: String
  ) {
    createOrUpdateCarrierFundingRequest(
      input: {
        id: $id
        amount: $amount
        debtorAdvanceAmount: $debtorAdvanceAmount
        debtor: $debtor
        contractType: $contractType
        userLoadNumber: $userLoadNumber
        billToCompanyPhone: $billToCompanyPhone
        billToCompanyEmail: $billToCompanyEmail
        billToAddress: {
          streetOne: $streetOne
          city: $city
          state: $state
          zip: $zip
          country: $country
        }
        fuelAdvanceAmount: $fuelAdvanceAmount
        nonFactored: $nonFactored
        firstOriginLocation: $originLocations
        finalDestinationLocation: $destinationLocations
        autoInvoice: $autoInvoice
        markedAsCompleted: $markedAsCompleted
        status: $status
        statusNote: $statusNote
      }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;

export const MUTATION_SUBMIT_FR_TO_DOCUMENT_REVIEW = gql`
  mutation SubmitFundingRequestToDocumentReview($id: ID!) {
    submitFundingRequestToDocumentReview(id: $id) {
      success
      fundingRequest {
        id
        status
      }
    }
  }
`;
